export default __webpack_public_path__ + "static/media/614.fdd863a7.gif";